import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"
import { ButtonComponentProps, DeleteButtonComponentProps } from "@quillsql/react"
import { ReactNode } from "react"

import { Button, IconButton, Tooltip } from "@atoms/index"

import styles from "./QuillButton.module.scss"

function QuillButtonIcon(props: { icon: ReactNode }) {
    const { icon } = props
    return <span className={styles.buttonIcon}>{icon}</span>
}

export function QuillButton(props: ButtonComponentProps) {
    const { primary, label, icon, tooltipText, onClick, width, disabled, isLoading } = props

    return (
        <Tooltip label={tooltipText}>
            <Button
                colorScheme="gray"
                size="md"
                variant={primary ? "solid" : "subtle"}
                isDisabled={disabled}
                isLoading={isLoading}
                onClick={onClick}
                style={width ? { width: width } : {}}
            >
                {icon ? <QuillButtonIcon icon={icon} /> : null}
                {label}
            </Button>
        </Tooltip>
    )
}

export function QuillDeleteButton(props: DeleteButtonComponentProps) {
    const { onClick } = props

    return (
        <Tooltip label="Remove">
            <IconButton
                colorScheme="gray"
                size="lg"
                variant="ghost"
                icon={icon({ name: "close", style: "light", family: "sharp" })}
                onClick={onClick}
            />
        </Tooltip>
    )
}
